import React, {Component} from 'react';

import './Header.css';
import connect from "react-redux/es/connect/connect";
import { motion } from "motion/react";

class Header extends Component {

    constructor(props) {

        super(props);
        this.state = {}
    }

    scrollToAfterLogo = () => {
      var objDiv = document.getElementById("postLogoSect");
      if (objDiv)
        objDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    render() {

        const {comp: {data}} = this.props;

        return (
            <div className='header'>
                {data && (data.logoBg || (data.sponsorsBg && data.sponsorsTop)) ? (
                    <div>
                        {data.logoBg ? (
                            <motion.div initial={{ scale: 0.4 }} animate={{ scale: 1,
                                transition: { duration: 2.5 } }} className={'logos-cont'}>
                                  {!data.logoFullscreen ? (
                                    <img src={data.logoBg.file} className={'pl-logo logo-image center-block'} />)
                                    : (<div ng-if="logoFullscreen" onClick={this.scrollToAfterLogo}
                                      className='logo-fullscreen'
                                      style={{background: `url(${data.logoBg.file}) no-repeat center center`, height: '100vh',
                                          backgroundSize: 'cover', cursor: 'pointer'}}></div>)
                                  }
                            </motion.div>
                        ) : null}
                        <div id="postLogoSect" style={{ visibility: 'hidden' }}></div>
                        {data.sponsorsBg && data.sponsorsTop ? (data.sponsorsLink && data.sponsorsLink != '') ? (
                            <a href={data.sponsorsLink} target="_blank">
                                <div className={'logos-cont'}>
                                    <img src={data.sponsorsBg.file} className={'pl-logo logo-image sponsors'}/>
                                </div>
                            </a>
                        ) : (
                            <div className={'logos-cont'}>
                                <img src={data.sponsorsBg.file} className={'pl-logo logo-image sponsors'}/>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        comp: things.competition,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
